import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { TurmaPlanejamentoOficina } from '../../../../core/turma-planejamento-oficina';

@Component({
  selector: 'listar-turmas-planejamento-oficina',
  templateUrl: './listar-turmas-planejamento-oficina.component.html',
  styleUrls: ['./listar-turmas-planejamento-oficina.component.css']
})
export class ListarTurmasPlanejamentosOficinasComponent implements OnInit {

  @Output() onAtualizarTurma = new EventEmitter();
  @Output() onAdicionar = new EventEmitter();

  @Input() turmasPlanejamentosOficinas: TurmaPlanejamentoOficina[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['turma', 'niveis', 'turno', 'acoes'];
  dataSource: MatTableDataSource<TurmaPlanejamentoOficina> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.carregarLista();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["turmasPlanejamentosOficinas"] && !_.isEmpty(changes["turmasPlanejamentosOficinas"].currentValue)) {
      this.carregarLista();
    }
  }

  carregarLista() {
      if (_.isEmpty(this.turmasPlanejamentosOficinas)) {
        this.mostrarTabela = false;
        this.msg = 'Nenhum material cadastrado.';
      } else {
        this.dataSource.data = this.turmasPlanejamentosOficinas;
        this.mostrarTabela = true;
    }
  }

  deletar(turmaAtividade: any): void {
    const index = this.turmasPlanejamentosOficinas.indexOf( this.turmasPlanejamentosOficinas.find(col => col === turmaAtividade));
    if (index >= 0) {
      this.turmasPlanejamentosOficinas.splice(index, 1);
      this.carregarLista();
    }
  }

  atualizar(turmaPlanejamentoOficina: TurmaPlanejamentoOficina) {
    this.onAtualizarTurma.emit(turmaPlanejamentoOficina);
  }

  novo() {
    this.onAdicionar.emit(true);
  }

}
